"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ringVariants = exports.ringSize = exports.svgValues = exports.variantColors = void 0;
exports.variantColors = {
  default: {
    progressRingColor: '--hmf-primary500',
    bgRingColorBeforeTarget: '--hmf-border-base-subtle',
    bgRingColorAfterTarget: '--hmf-primary500'
  },
  points: {
    progressRingColor: '--hmf-scgreen',
    bgRingColorBeforeTarget: '--hmf-border-base-subtle',
    bgRingColorAfterTarget: '--hmf-primary100'
  },
  gold: {
    progressRingColor: '--hmf-gold400',
    bgRingColorBeforeTarget: '--hmf-border-base-subtle',
    bgRingColorAfterTarget: '--hmf-gold100'
  },
  secondary: {
    progressRingColor: '--hmf-secondary600',
    bgRingColorBeforeTarget: '--hmf-border-base-subtle',
    bgRingColorAfterTarget: '--hmf-secondary500'
  },
  alert: {
    progressRingColor: '--hmf-accent700',
    bgRingColorBeforeTarget: '--hmf-border-base-subtle',
    bgRingColorAfterTarget: '--hmf-accent600'
  }
};
exports.svgValues = {
  small: {
    circleStrokeLength: 98,
    containerDiameter: 40,
    ringRadio: 16,
    strokeWidth: 6,
    pointsTextY: '0',
    closingMarginPercentage: 0.08
  },
  medium: {
    circleStrokeLength: 387,
    containerDiameter: 136,
    ringRadio: 62,
    strokeWidth: 8,
    pointsTextY: '62%',
    closingMarginPercentage: 0.03
  },
  large: {
    circleStrokeLength: 777,
    containerDiameter: 264,
    ringRadio: 124,
    strokeWidth: 10,
    pointsTextY: '60%',
    closingMarginPercentage: 0.02
  }
};
exports.ringSize = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};
exports.ringVariants = {
  default: 'default',
  points: 'points',
  gold: 'gold',
  secondary: 'secondary',
  alert: 'alert'
};
